export default "__VITE_ASSET__DmPhzMBD__"